<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 14:57:15
 * @LastEditTime: 2020-09-11 16:23:29
 * @Description: 产品组筛选条件
 -->
<template>
  <div class="product-group-filter">
    <i-checkbox class="title"
      :indeterminate="indeterminate"
      :value="checkAll" @click.prevent.native="selectAllOrCanelAll">产品组</i-checkbox>
    <i-checkbox-group v-model="productGroupCodesFilter" @on-change="checkGroupChanged">
      <i-checkbox
        v-for="(groupCode, index) in productGroupCodes"
        :key="index" :label="groupCode" />
    </i-checkbox-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ProductGroupFilter',
  props: {
    productGroupCodes: { type: Array, required: true },
  },
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      productGroupCodesFilter: [],
    };
  },
  computed: {
    groupsFilterStore() {
      return this.$store.state.libraryStore.filters.productGroupCodes;
    },
  },
  watch: {
    productGroupCodesFilter(productGroupCodes) {
      this.setProductGroupCodesFilter({ productGroupCodes });
    },
    groupsFilterStore(productGroupCodes) {
      this.productGroupCodesFilter = productGroupCodes;

      if (productGroupCodes.length === 0) {
        this.checkAll = false;
        this.indeterminate = false;
      }

      this.requestProductListAndSetting();
    },
  },
  methods: {
    ...mapActions({
      setProductGroupCodesFilter: 'libraryStore/invokeSetProductGroupCodesFilter',
    }),
    /**
     * 产品组筛选全选与取消全选
     */
    selectAllOrCanelAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      this.productGroupCodesFilter = [];
      if (this.checkAll) {
        this.productGroupCodes.forEach((code, index) => {
          this.$set(this.productGroupCodesFilter, index, code);
        });
      }
    },
    /**
     * 复选框组变化
     */
    checkGroupChanged(productGroupCodes) {
      if (productGroupCodes.length === this.productGroupCodes.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (productGroupCodes.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    /**
     * 请求产品简称列表并设置
     */
    requestProductListAndSetting() {
      this.requestProductList()
        .then((productList) => {
          this.$emit('set-product-list', productList);
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求产品简称列表
     */
    requestProductList() {
      const parmas = {
        groupCodes: this.groupsFilterStore.join(','),
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.libraryFilterProductList(parmas);

        if (result.result && result.code === '200' && result.data) {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.product-group-filter {
  width: 100%;

  > .title {
    margin-bottom: 12px;
    font-size: 13px;

    /deep/ .ivu-checkbox {
      margin-right: 6px;
    }
  }

  /deep/ .ivu-checkbox-group {
    padding-left: 26px;

    .ivu-checkbox-group-item {
      font-size: 13px;

      .ivu-checkbox {
        margin-right: 6px;
      }
    }
  }
}
</style>
